import { createTheme } from "@mui/material/styles";

const flowlineThreadTheme = createTheme({
  palette: {
    mode: "light",

    primary: {
      main: "#6D28D9", // Softer violet (Threads vibe)
    },

    secondary: {
      main: "#0EA5E9", // Calm blue accent
    },

    background: {
      default: "#F9FAFB", // Lighter, airier background
      paper: "#FFFFFF",
    },

    text: {
      primary: "#111827",
      secondary: "#6B7280",
    },

    divider: "rgba(17, 24, 39, 0.08)",
  },

  typography: {
    fontFamily: '"Inter", system-ui, sans-serif',

    h1: {
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },

    h2: {
      fontWeight: 600,
      letterSpacing: "-0.015em",
    },

    h3: {
      fontWeight: 500,
    },

    body1: {
      fontSize: "0.95rem",
      lineHeight: 1.7,
    },

    body2: {
      fontSize: "0.85rem",
      lineHeight: 1.6,
      color: "#6B7280",
    },

    button: {
      textTransform: "none",
      fontWeight: 500,
    },
  },

  shape: {
    borderRadius: 10, // Slightly rounded, modern Threads feel
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F9FAFB",
          overflowX: "hidden",
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          transition: "all 0.15s ease",

          "&:hover": {
            backgroundColor: "#FFFFFF",
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            transform: "translateY(-1px)",
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999, // 🔥 pill buttons (Threads)
          padding: "6px 14px",
        },

        contained: {
          backgroundColor: "#6D28D9",
          boxShadow: "none",

          "&:hover": {
            backgroundColor: "#5B21B6",
            boxShadow: "none",
          },
        },

        outlined: {
          borderColor: "rgba(0,0,0,0.15)",
          color: "#111827",

          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.04)",
          },
        },

        text: {
          "&:hover": {
            backgroundColor: "rgba(109, 40, 217, 0.06)",
          },
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          margin: "10px 0",
        },
      },
    },

    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 38,
          height: 38,
          fontSize: "0.9rem",
          backgroundColor: "#EDE9FE",
          color: "#6D28D9",
        },
      },
    },

    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "8px 12px",

          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.035)",
          },
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#6B7280",

          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.04)",
          },
        },
      },
    },
  },
});

export default flowlineThreadTheme;
